import { useState, useEffect } from 'react';

const MQ = '(prefers-reduced-motion: reduce)';

/**
 * Standalone reduced-motion hook — no Framer Motion dependency.
 * Use in components that must stay FM-free (e.g. AnimatedCollapse).
 * Subscribes to live changes in the user's OS/browser motion preference.
 */
export function useReducedMotion(): boolean {
  const [prefersReduced, setPrefersReduced] = useState(
    () => typeof window !== 'undefined' && window.matchMedia?.(MQ).matches,
  );

  useEffect(() => {
    const mql = window.matchMedia(MQ);
    const handler = (e: MediaQueryListEvent) => setPrefersReduced(e.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return prefersReduced;
}
